export default __webpack_public_path__ + "static/media/porsche.7f5ac973.png";